import { Reducer } from 'redux';

import { DeleteCartItemDiscountActionTypes, DeleteCartItemDiscountActions } from '../actions/DeleteCartItemDiscount';
import { IErrorActionData } from '../../../models/Error';

export interface IDeleteCartItemDiscountState {
  isProcessing: boolean;
  isSuccess: boolean;
  error?: IErrorActionData;
}

const initialDeleteCartItemDiscountState = {
  isProcessing: false,
  isSuccess: false,
  error: undefined,
} as IDeleteCartItemDiscountState;

const DeleteCartItemDiscountReducer: Reducer<IDeleteCartItemDiscountState, DeleteCartItemDiscountActions> = (
  state = initialDeleteCartItemDiscountState,
  action: DeleteCartItemDiscountActions,
): IDeleteCartItemDiscountState => {
  switch (action.type) {
    case DeleteCartItemDiscountActionTypes.DELETE_CART_ITEM_DISCOUNT:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case DeleteCartItemDiscountActionTypes.DELETE_CART_ITEM_DISCOUNT_SUCCESS: {
      return {
        ...state,
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };
    }

    case DeleteCartItemDiscountActionTypes.DELETE_CART_ITEM_DISCOUNT_FAILED:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case DeleteCartItemDiscountActionTypes.DELETE_CART_ITEM_DISCOUNT_RESET:
      return initialDeleteCartItemDiscountState;

    default:
      return state;
  }
};

export default DeleteCartItemDiscountReducer;
